(() => {
  if (customElements.get('argimo-campaign-countdown')) return;

  class ArgimoCampaignCountdown extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.editor = this.dataset.editor === 'true';
      this.previewEnded = this.editor && this.dataset.previewEnded === 'true';
      this.target = this.parseTarget();
      this.waitingElements = this.querySelectorAll('[data-waiting]');
      this.endedElements = this.querySelectorAll('[data-ended]');
      this.digits = ['days', 'hours', 'minutes', 'seconds'].map((unit) => this.querySelector(`[data-${unit}]`));

      if (!Number.isFinite(this.target)) {
        this.hidden = !this.editor;
        this.showEditorNote('Geçerli bir hedef tarih (YYYY-AA-GG) ve saat (SS:DD) girin. Türkiye saati kullanılır.');
        this.setEnded(this.previewEnded);
        this.digits.forEach((digit) => { if (digit) digit.textContent = '00'; });
        return;
      }

      this.update();
      if (this.target > Date.now() && !this.previewEnded) {
        this.interval = window.setInterval(() => this.update(), 1000);
      }
    }

    disconnectedCallback() {
      this.stop();
    }

    parseTarget() {
      const date = (this.dataset.date || '').trim();
      const time = (this.dataset.time || '').trim();
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^\d{2}:\d{2}(:\d{2})?$/.test(time)) return NaN;

      const [year, month, day] = date.split('-').map(Number);
      const [hour, minute, second = 0] = time.split(':').map(Number);
      if (year < 1000 || month < 1 || month > 12 || day < 1 || day > 31 || hour > 23 || minute > 59 || second > 59) return NaN;

      // Reject dates such as February 30 instead of allowing Date to roll into March.
      const calendar = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
      if (calendar.getUTCFullYear() !== year || calendar.getUTCMonth() !== month - 1 || calendar.getUTCDate() !== day) return NaN;

      // The same instant is used for every visitor, regardless of their device time zone.
      return calendar.getTime() - 3 * 60 * 60 * 1000;
    }

    update() {
      const remaining = Math.max(0, Math.ceil((this.target - Date.now()) / 1000));
      const ended = remaining === 0 || this.previewEnded;
      const hideEnded = ended && this.dataset.hideEnded === 'true';
      this.hidden = hideEnded && !this.editor;
      this.setEnded(ended);

      const values = [
        Math.floor(remaining / 86400),
        Math.floor(remaining % 86400 / 3600),
        Math.floor(remaining % 3600 / 60),
        remaining % 60
      ];
      this.digits.forEach((digit, index) => {
        const value = String(values[index]).padStart(2, '0');
        if (digit && digit.textContent !== value) digit.textContent = value;
      });

      this.showEditorNote(hideEnded ? 'Süre doldu. Bandı gizle seçeneği açık olduğu için bu bölüm mağazada görünmez.' : '');
      if (ended) this.stop();
    }

    setEnded(ended) {
      this.waitingElements.forEach((element) => { element.hidden = ended; });
      this.endedElements.forEach((element) => { element.hidden = !ended; });
    }

    showEditorNote(message) {
      const note = this.querySelector('[data-editor-note]');
      if (!note) return;
      note.textContent = message;
      note.hidden = !message;
    }

    stop() {
      window.clearInterval(this.interval);
      this.interval = undefined;
    }
  }

  customElements.define('argimo-campaign-countdown', ArgimoCampaignCountdown);
})();
